import React, {useEffect} from 'react'
import { useTranslation } from 'react-i18next'
import {observer} from 'mobx-react'
import {useInjection} from 'dna-react-ioc'

import {withTitle} from '@/router/utils'
import {PageContainer} from '@/components'

import {ApplicationProgress} from './components'

import {IApplicationProgressStore} from './IApplicationProgressStore'
import styles from './ApplicationProgressPage.scss'

export const ApplicationProgressStoreSymbol = Symbol.for('ApplicationProgressStoreSymbol')

const ApplicationProgressPage: React.FC<null> = observer(() => {
    const { t } = useTranslation()
    const store = useInjection<IApplicationProgressStore>(ApplicationProgressStoreSymbol)

    useEffect(() => {
        const stopPolling = store.startStatusPolling()
        return stopPolling
    }, [store])

    return (
        <PageContainer
            title={t('ApplicationProgress.yourApplicationProgress')}
            isLoading={store.isLoading}
            hasBack={false}
        >
            <div className={styles.applicationProgressContainer}>
                <ApplicationProgress currentStep={store.currentStep} />
            </div>
        </PageContainer>
    )
})

export default withTitle(ApplicationProgressPage, 'ApplicationProgress.applicationProgressTitle')
